import logo from '../../assets/images/rexomovers_blue.png'

export default function FallbackPage() {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" style={{ height: '300px' }} />
                </div>
            </div>
        </>
    )
}